__turbopack_context__.v({
  "column": "nj7T7q_column",
  "linkIcon": "nj7T7q_linkIcon",
  "section": "nj7T7q_section",
  "teamCol": "nj7T7q_teamCol",
  "teamInfo": "nj7T7q_teamInfo",
  "teamLogo": "nj7T7q_teamLogo",
  "teamName": "nj7T7q_teamName",
  "teamTag": "nj7T7q_teamTag",
});
